import en from './en.json';

export default {
  en: {
    translation: en,
  },
};
